import { useEffect, useRef } from 'react';

export default function SendPulseForm() {
  const formRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Always load SendPulse script
    const script = document.createElement('script');
    script.src = '//web.webformscr.com/apps/fc3/build/loader.js';
    script.async = true;
    script.setAttribute('sp-form-id', '3e9e4ed1db79410329e180db59cabe4fe1a088014a79b66fb2e31f3849b84c8a');
    script.setAttribute('data-cookieconsent', 'ignore'); // Add cookieconsent ignore attribute
    
    // Add script if it doesn't exist
    if (!document.querySelector('script[sp-form-id]')) {
      formRef.current?.appendChild(script);
    }

    return () => {
      // Cleanup on unmount
      if (formRef.current?.contains(script)) {
        formRef.current.removeChild(script);
      }
    };
  }, []);

  return (
    <div 
      ref={formRef} 
      className="bg-white rounded-lg overflow-hidden"
      data-cookieconsent="ignore" // Add cookieconsent ignore attribute to container
    />
  );
}